module.exports = __webpack_public_path__ + "img/PorkFrance.95a6f671.png";